<template>
  <el-container v-title data-title="交易记录" style="min-height:98vh">
    <el-header style="text-align: right; font-size: 12px; height: 105px; background-image: linear-gradient(to right, white , green);">
      <Top/>
    </el-header>
    <el-container>
      <el-aside width="200px" style="background-color: rgb(238, 241, 246)">
        <Menu @GoTo='goto'></Menu>
      </el-aside>
      <el-main style="width: 1px">
        <el-header style="height: auto; padding: 0; background-color: #FFF">
          <el-container>
            <el-header height="20px" style="padding: 0; background-color: #FFF">
              <el-breadcrumb separator="/">
                <el-breadcrumb-item>食堂管理</el-breadcrumb-item>
                <el-breadcrumb-item>交易记录</el-breadcrumb-item>
              </el-breadcrumb>
            </el-header>
            <el-main>
              <el-form :inline="true" :model="searchForm" class="demo-form-inline" >
                <el-form-item label="学校">
                  <el-select v-model="searchForm.schoolId" filterable>
                    <el-option v-for="(item, index) in schoolList" :key="index" :label="item.name" :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="姓名">
                  <el-input v-model="searchForm.userRealName" placeholder="姓名"></el-input>
                </el-form-item>
                <el-form-item label="类型">
                  <el-select v-model="searchForm.type" placeholder="类型">
                    <el-option label="全部" value=""></el-option>
                    <el-option label="食堂-增值" value="00"></el-option>
                    <el-option label="食堂-用户账户充值" value="01"></el-option>
                    <el-option label="食堂-用户账户取值" value="02"></el-option>
                    <el-option label="食堂-用户账户撤销" value="03"></el-option>
                    <el-option label="食堂-反增值" value="04"></el-option>
                    <el-option label="食堂-用户账户启用" value="05"></el-option>
                    <el-option label="食堂-订单取消" value="20"></el-option>
                    <el-option label="食堂-订单手动核销" value="21"></el-option>
                    <el-option label="食堂-计划外交易手动核销" value="22"></el-option>
                    <el-option label="食堂-订单退款" value="23"></el-option>
                    <el-option label="食堂-计划外交易退款" value="24"></el-option>
                    <el-option label="食堂-商品订单价格调整补差额" value="25"></el-option>
                    <el-option label="食堂-商品订单价格调整退差额" value="26"></el-option>
                    <el-option label="系统-用户周订单额锁定" value="40"></el-option>
                    <el-option label="系统-订单自动核销" value="41"></el-option>
                    <el-option label="系统-订单超时自动核销" value="42"></el-option>
                    <el-option label="系统-超时自动核销商品失败退款" value="43"></el-option>
                    <el-option label="系统-商品订单超时自动核销" value="44"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="起始时间">
                  <el-date-picker
                    v-model="searchForm.searchTimeFrom"
                    type="datetime"
                    placeholder="选择起始时间"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    :picker-options="pickerOptions">
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="结束时间">
                  <el-date-picker
                    v-model="searchForm.searchTimeTo"
                    type="datetime"
                    placeholder="选择结束时间"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    :picker-options="pickerOptions">
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="每页条数">
                  <el-select v-model="pageSize" @change="handleSizeChange" style="width:80px">
                    <el-option v-for="(item, index) in pageSizes" :key="index" :label="item" :value="item"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="getTransactionList">查询</el-button>
                </el-form-item>
              </el-form>
            </el-main>
          </el-container>
        </el-header>
        <el-table v-loading="loading" :data="tableData" border stripe>
          <el-table-column prop="insertTime" label="交易时间" width="170" fixed></el-table-column>
          <el-table-column prop="userRealName" label="用户姓名" width="100" fixed></el-table-column>
          <el-table-column prop="typeName" label="类型" width="190" fixed></el-table-column>
          <el-table-column prop="amount" :formatter="yuanOfAmountFormatter" label="交易额" width="70" fixed></el-table-column>
          <el-table-column prop="id" label="交易编号" width="310"></el-table-column>
          <el-table-column prop="schoolName" label="学校" width="180"></el-table-column>
          <el-table-column prop="schoolAccountId" label="学校账户编号" width="310"></el-table-column>
          <el-table-column prop="userAccountId" label="用户账户编号" width="310"></el-table-column>
          <el-table-column prop="goodsTypeName" label="货品类型" width="77"></el-table-column>
          <el-table-column prop="relationTransactionId" label="关联交易编号" width="310"></el-table-column>
          <el-table-column prop="relationWeekMenuName" label="关联周菜单" width="91"></el-table-column>
          <el-table-column prop="relationOrderId" label="关联订单编号" width="310"></el-table-column>
          <el-table-column prop="userBalanceBefore" :formatter="yuanOfUserBalanceBeforeFormatter" label="交易前用户账户可用额" width="100"></el-table-column>
          <el-table-column prop="userBalanceAfter" :formatter="yuanOfUserBalanceAfterFormatter" label="交易后用户账户可用额" width="100"></el-table-column>
          <el-table-column prop="userLockedBalanceShoppingBefore" :formatter="yuanOfUserLockedBalanceShoppingBeforeFormatter" label="交易前用户账户订餐时锁定额" width="100"></el-table-column>
          <el-table-column prop="userLockedBalanceShoppingAfter" :formatter="yuanOfUserLockedBalanceShoppingAfterFormatter" label="交易后用户账户订餐时锁定额" width="100"></el-table-column>
          <el-table-column prop="userLockedBalanceBefore" :formatter="yuanOfUserLockedBalanceBeforeFormatter" label="交易前用户账户订餐后锁定额" width="100"></el-table-column>
          <el-table-column prop="userLockedBalanceAfter" :formatter="yuanOfUserLockedBalanceAfterFormatter" label="交易后用户账户订餐后锁定额" width="100"></el-table-column>
          <!-- <el-table-column prop="schoolBalanceBefore" :formatter="yuanOfSchoolBalanceBeforeFormatter" label="交易前学校账户可用额" width="100"></el-table-column>
          <el-table-column prop="schoolBalanceAfter" :formatter="yuanOfSchoolBalanceAfterFormatter" label="交易后学校账户可用额" width="100"></el-table-column> -->
          <el-table-column prop="schoolIncreaseAccountBalanceBefore" :formatter="yuanOfSchoolIncreaseAccountBalanceBeforeFormatter" label="交易前学校增值账户可用额" width="100"></el-table-column>
          <el-table-column prop="schoolIncreaseAccountBalanceAfter" :formatter="yuanOfSchoolIncreaseAccountBalanceAfterFormatter" label="交易后学校增值账户可用额" width="100"></el-table-column>
          <el-table-column prop="schoolRecycleAccountBalanceBefore" :formatter="yuanOfSchoolRecycleAccountBalanceBeforeFormatter" label="交易前学校回收账户可用额" width="100"></el-table-column>
          <el-table-column prop="schoolRecycleAccountBalanceAfter" :formatter="yuanOfSchoolRecycleAccountBalanceAfterFormatter" label="交易后学校回收账户可用额" width="100"></el-table-column>
        </el-table>
        <div>
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="getTransactionList"
            :current-page.sync="currentPage"
            :page-sizes="pageSizes"
            :page-size="pageSize"
            :total="total"
            layout="total,sizes,prev,pager,next" >
          </el-pagination>
        </div>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import Top from './Top.vue'
import Menu from './Menu.vue'
export default ({
  components: {
    Menu,
    Top
  },
  data () {
    return {
      userInfo: {},
      schoolList: [],
      tableData: [],
      loading: false,
      currentPage: 1,
      pageSize: 15,
      pageSizes: [15, 50, 100, 150, 200, 300, 500, 1000, 2000],
      total: 0,
      searchForm: {
        schoolId: null,
        type: ''
      },
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now()
        }
      }
    }
  },
  mounted () {
    if (this.Cookie.get('userInfo') !== undefined && this.Cookie.get('userInfo') !== '') {
      this.userInfo = JSON.parse(this.Cookie.get('userInfo'))
      this.getSchoolList()
    }
  },
  methods: {
    goto (url) {
      if (url === this.$route.path) return
      this.$router.push(url)
    },
    handleClose (done) {
      done()
    },
    handleSizeChange (pageSize) {
      this.pageSize = pageSize
      this.getTransactionList()
    },
    getSchoolList () {
      let _this = this
      this.$axios.post(this.GLOBAL.host + '/school/list',
        this.$qs.stringify({
          currentUserId: _this.userInfo.id,
          filterCanteen: '1'
        })
      ).then(res => {
        if (res.data != null) {
          if (res.data.status === 200) {
            _this.schoolList = res.data.data.list
            if (_this.schoolList.length > 0) {
              _this.searchForm.schoolId = _this.schoolList[0].id
              _this.getTransactionList()
            }
          } else {
            this.$message.error(res.data.message)
          }
        }
      })
    },
    getTransactionList () {
      let _this = this
      _this.loading = true
      if (_this.searchForm.schoolId === null) return
      this.$axios.post(this.GLOBAL.host + '/canteenTransaction/list',
        this.$qs.stringify({
          schoolId: _this.searchForm.schoolId,
          type: _this.searchForm.type,
          userRealName: _this.searchForm.userRealName,
          searchTimeFrom: _this.searchForm.searchTimeFrom,
          searchTimeTo: _this.searchForm.searchTimeTo,
          page: _this.currentPage,
          size: _this.pageSize
        })
      ).then(res => {
        if (res.data != null) {
          if (res.data.status === 200) {
            _this.total = res.data.data.total
            _this.tableData = res.data.data.list
          }
        }
        _this.loading = false
      })
    },
    yuanOfAmountFormatter (row) {
      return this.fenToyuanFormat(row.amount)
    },
    yuanOfUserBalanceBeforeFormatter (row) {
      return this.fenToyuanFormat(row.userBalanceBefore)
    },
    yuanOfUserBalanceAfterFormatter (row) {
      return this.fenToyuanFormat(row.userBalanceAfter)
    },
    yuanOfUserLockedBalanceShoppingBeforeFormatter (row) {
      return this.fenToyuanFormat(row.userLockedBalanceShoppingBefore)
    },
    yuanOfUserLockedBalanceShoppingAfterFormatter (row) {
      return this.fenToyuanFormat(row.userLockedBalanceShoppingAfter)
    },
    yuanOfUserLockedBalanceBeforeFormatter (row) {
      return this.fenToyuanFormat(row.userLockedBalanceBefore)
    },
    yuanOfUserLockedBalanceAfterFormatter (row) {
      return this.fenToyuanFormat(row.userLockedBalanceAfter)
    },
    // yuanOfSchoolBalanceBeforeFormatter (row) {
    //   return this.fenToyuanFormat(row.schoolBalanceBefore)
    // },
    // yuanOfSchoolBalanceAfterFormatter (row) {
    //   return this.fenToyuanFormat(row.schoolBalanceAfter)
    // },
    yuanOfSchoolIncreaseAccountBalanceBeforeFormatter (row) {
      return this.fenToyuanFormat(row.schoolIncreaseAccountBalanceBefore)
    },
    yuanOfSchoolIncreaseAccountBalanceAfterFormatter (row) {
      return this.fenToyuanFormat(row.schoolIncreaseAccountBalanceAfter)
    },
    yuanOfSchoolRecycleAccountBalanceBeforeFormatter (row) {
      return this.fenToyuanFormat(row.schoolRecycleAccountBalanceBefore)
    },
    yuanOfSchoolRecycleAccountBalanceAfterFormatter (row) {
      return this.fenToyuanFormat(row.schoolRecycleAccountBalanceAfter)
    },
    fenToyuanFormat (fen) {
      let yuan = ''
      if (fen !== 0) {
        yuan = fen / 100 + '元'
      }
      return yuan
    }
  }
})
</script>



// WEBPACK FOOTER //
// src/components/CanteenTransaction.vue